import * as React from "react";

import { cn } from "@/lib/utils";

interface SectionHeadProps {
  /** Small uppercase eyebrow above the title. */
  kicker?: string;
  /** Newsreader section title. */
  title: string;
  /** Optional right-aligned aside (a small note, a ghost button, etc.). */
  aside?: React.ReactNode;
  className?: string;
}

/**
 * Eyebrow + Newsreader title section header — the one section-heading pattern
 * for the org profile. Tokens only; Newsreader comes from `font-display`.
 */
const SectionHead = ({ kicker, title, aside, className }: SectionHeadProps) => (
  <div className={cn("mb-[18px] flex flex-wrap items-end justify-between gap-4", className)}>
    <div className="min-w-0 flex-1">
      {kicker && <div className="eyebrow mb-2.5 text-ink-500">{kicker}</div>}
      <h2 className="m-0 font-display text-2xl font-semibold leading-[1.12] text-ink-900">{title}</h2>
    </div>
    {aside}
  </div>
);

export default SectionHead;
